import { NgModule } from '@angular/core';
import { ArrayHelper } from './helper/array.helper';
import { ObjectHelper } from './helper/object.helper';
import { RandomHelper } from './helper/random.helper';
import { StringHelper } from './helper/string.helper';
import { StyleHelper } from './helper/style.helper';

@NgModule({
    declarations: [
    ],
    imports: [
    ],
    providers: [
        ArrayHelper,
        ObjectHelper,
        RandomHelper,
        StringHelper,
        StyleHelper
    ]
})
export class CommonModule { }
export * from './helper/array.helper';
export * from './helper/object.helper';
export * from './helper/random.helper';
export * from './helper/string.helper';
export * from './helper/style.helper';
